import Splide from '@splidejs/splide';

export const initaliseSplide = () => {
    const splides = document.querySelectorAll('.js-splide');

    if (!splides.length) return;

    splides.forEach((splide) => {
        const prevButton = splide.closest('.js-splide-wrapper').querySelector('.splide__arrow--prev');
        const nextButton = splide.closest('.js-splide-wrapper').querySelector('.splide__arrow--next');

        const splideInstance = new Splide(splide, {
            type: splide.dataset.type ?? 'loop',
            perPage: splide.dataset.columnsXl ?? 4,
            perMove: 1,
            gap: '40px',
            pagination: false,
            arrows: false, // Disable default arrows
            updateOnMove: true,
            fixedWidth: splide.dataset.sizeXl ?? undefined,
            breakpoints: {
                1280: { perPage: 4, fixedWidth: splide.dataset.sizeLg ?? undefined }, // 1/4 width default
                1024: { perPage: 4, fixedWidth: splide.dataset.sizeMd ?? undefined }, // 1/4 width default
                768: { perPage: 2, gap: '12px', fixedWidth: splide.dataset.sizeSm ?? undefined },  // 1/2 width default
                640: { perPage: 1, gap: '12px', fixedWidth: splide.dataset.sizeSm ?? undefined },  // Full width default
            },
            focus: 'end',
        });

        const secondarySplide = splide.closest('.items')?.querySelector('.js-splide-secondary');
        let secondaryInstance;

        if (secondarySplide) {
            secondaryInstance = new Splide(secondarySplide, {
                type: 'fade',
                heightRatio: 0.43,
                pagination: false,
                arrows: false,
                cover: true,
            });

            splideInstance.sync(secondaryInstance);
            secondaryInstance.mount();
        }

        splideInstance.on('mounted', () => {
            if (prevButton) {
                prevButton.addEventListener('click', () => splideInstance.go('<'));
            }
            if (nextButton) {
                nextButton.addEventListener('click', () => splideInstance.go('>'));
            }
        });

        splideInstance.mount();
    });
};
